import _ from 'lodash';
import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER, formatQueryParams } from '../../utils';

export const getSearchQueryPath = ({ query, filter, id, queryParams, source }) => {
    let params;
    if (_.isString(queryParams)) {
        params = { query, ref: queryParams };
        if (id) {
            params = { ...params, sub_category: id };
        }

    } else {
        params = { ...queryParams, query };
    }

    return pathfinder(PATHFINDER.SEARCH, {}, formatQueryParams({ filter, queryParams: params, source }));
};
